import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '~/store';
import { Footer } from './styles';

export default function () {
  const { company } = useSelector<ApplicationState, any>(state => state.auth);

  return (
    <Footer className="footer-fix">
      <ul>
        <li>
          <span>Copyright © 2020 Vrio Corp. All rights reserved.</span>
        </li>
        <li>
          <a href={`/${company?.path_alias_nm}/politica-de-privacidade`}>
            Política de privacidade
          </a>
        </li>
        {company?.country_company_id !== 2 ? (
          <li>
            <a href={`/${company?.path_alias_nm}/faq`}>FAQ</a>
          </li>
        ) : (
          ''
        )}
      </ul>
    </Footer>
  );
}
